// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_Settings.scss
// module id = 672
// module chunks = 63 88